import { PresentationStatus } from "../interfaces/IPresentationStatus";
import { getPresentationStatusStyles } from "./scheduleStatusStyles";
import { Theme } from "@mui/material";
import { SystemStyleObject } from "@mui/system";

export const getPresentationRowStyles = (
  currentStatus: PresentationStatus,
  theme: Theme,
): SystemStyleObject<Theme> => {
  switch (currentStatus) {
    case PresentationStatus.DANCING:
    case PresentationStatus.PLANNED:
      return getPresentationStatusStyles(currentStatus, theme);
    case PresentationStatus.DONE:
      return getPresentationStatusStyles(currentStatus, theme, { includeBackground: true });
    case PresentationStatus.REMOVED:
      return {
        backgroundColor: theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.05)" : "rgba(0, 0, 0, 0.03)",
        opacity: 0.6,
        "& > td": {
          textDecoration: "line-through",
          color: theme.palette.text.secondary,
        },
      };
    default:
      return {};
  }
};

export const getPresentationBaseRowStyles = (theme: Theme) => ({
  borderBottom: "1px solid",
  borderBottomColor: theme.palette.mode === "dark" ? "grey.700" : "divider",
  "& > td": {
    py: 1,
    px: 1.5,
    borderBottom: "none",
  },
});
